<template>
  <div>
    <sbanner />
    <div class="container">
      
      <div class="news-detail" v-if="detailOne">
        <div class="news-detail-in">
          <loading  v-if="showLoading"/>
          <div class="news-title">
            {{detailOne.title}}
          </div>
          <div class="news-pub">
            <span v-if="detailOne.pub_time">发布时间：{{detailOne.pub_time}} </span>
            <span v-if="detailOne.source"> 来源：{{detailOne.source}}</span>
            <div class="actionBox">
              <Actions 
                v-if="detailOne.id"
                banner="4"
                :view="detailOne.browse_count"
                :collect="detailOne.collect_count"
                :like="detailOne.like_count"
                :row="detailOne"
              />
            </div>
          </div>
          <div class="news-intro" v-html="detailOne.content">
            
          </div>

          <!-- //品牌活动关联 -->
          <div class="relevance" v-if="detailOne.activity_id">
            <div class="relavance-title">关联活动</div>
            <div class="relavance-content" @click="goRelate('activity',detailOne.activity_id)">
              <p>{{detailOne.activity_name}}</p>
              <span>>></span>
            </div>
          </div>

          <div class="relevance" v-if="detailOne.brand_id">
            <div class="relavance-title">关联品牌</div>
            <div class="relavance-content" @click="goRelate('brand',detailOne.brand_id)">
              <p>{{detailOne.brand_name}}</p>
              <span>>></span>
            </div>
          </div>
        </div>
        
        <div class="downFile" v-if="detailOne.attachment">
         <div class="title">附件信息</div>
         <div class="fileList">
            <div class="file-item"  @click="downFile(showpath + detailOne.attachment)">
               <!-- -->
              <span class="iconfont icon-folder-download-fill"></span>
              <div class="file-txt">
                <p class="name" :title="detailOne.attachmentname">{{detailOne.attachmentname}}</p>
                <p class="sub">{{detailOne.attachmentsize}}MB</p>
                <!-- ，下载次数：1 -->
              </div>
            </div>
         </div>
        </div>
      </div>
      
      <div class="news-relate" v-if="otherList &&　otherList.length>0">
        <div class="title">
          <span>延伸阅读</span>
        </div>
        <div class="relate-list">
          
          <div class="item" v-for="item in 　otherList">
            <router-link :to="{path:'/news/'+item.id}">
              <div class="item-time">{{item.pub_time}}</div>
              <div class="item-title">{{item.title}}</div>
            </router-link>
          </div>
        </div>
      </div>

     

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sbanner from '../components/sbanner.vue'
import Loading from '../components/common/loading.vue'
import Actions from '@/pages/exhibit/components/Actions.vue'
import { downloadZip } from "../utils/downloadZip"
import {download} from "../utils/download"
export default {
  components: { 
    sbanner,
    Loading,
    Actions
  },
  name: 'newsDetail',
  props: {
    msg: String
  },
  data(){
    return{
      newsId:-1,
      showpath:'',
      detailOne:{},
      showLoading:false,
      otherList:[],
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    this._getOne(this.id);
  },
  computed:{
    ...mapState(['userInfo'])
  },
  methods: {
    addRecord(curid,category=1){
      let params={
        banner:"新闻",
        id:curid,
        category:category
      }
      if (this.userInfo && this.userInfo.id) {
        params.user_id = this.userInfo.id
      }
      this.$api.recordApi.recordApis(params);
    },

    _getOne(id){
      this.showLoading =true;
      this.$api.newsApi.getOneById({id:id}).then(res=>{
        this.showpath = res.showpath;
        this.detailOne = res.data;
        this.detailOne.cover_img = this.detailOne.cover_img ? res.showpath + this.detailOne.cover_img : ''
        this.detailOne.content = this.setContent(this.detailOne.content)
        this.showLoading = false;
        this._getOtherList();
        
        this.$nextTick(() => {
          const imgs = this.$el.querySelectorAll('img');
          imgs.forEach(img => {
            img.onerror = () => {
              const srcArr = img.src.split('?')
              img.onerror = null
              img.src = srcArr[0]
            };
          });
        })
      })
    },

    _getOtherList(){
      let params={  
        id:this.id
      }
      this.$api.newsApi.getOtherList(params).then(res=>{
        this.otherList = res.data;
      })
    },
    goRelate(type,id){
      let path =''
      if(type=='activity'){
        path = "/activity/"
      } else{
        path ='/thematic/'
      }
       try {
        let link = this.$router.resolve({
          path:path +id
        })
        window.open(link.href,"_blank")
      } catch (error) {
        this.$router.push({
          path:path + id
        })
      }
    },
    downFile(fileSrc){
      this.addRecord(this.id,2)
      window.open(fileSrc)
      return;
      let data = [{
        url:fileSrc,
        filename:this.detailOne.attachmentname
      }]
      download.downloadAll(data)

    },

    

    async downZip(){
      let data=[];
      if(this.detailOne.attachment){
       let fileSource ={
          url:"http://gdwhgtest.wanjuan.cn/head_bg.png",
          // url:this.showpath + this.detailOne.attachment,
          file_name:this.detailOne.attachmentname
        }
        data.push(fileSource)
      }
      await downloadZip.handleBatchDownload(data)
      // await downloadZip.handleBatchDownload(data)
    },
    
  },
}
</script>
<style lang="scss" scoped >
.news-pub {
  position: relative;
  .actionBox {
    position: absolute; 
    right: 0;
    top: 0;
  }
}

</style>